<template>
  <section>
    <el-upload action="#" :class="{ hide: hideUpload }" list-type="picture-card" :limit="imgLimit"
      :show-file-list="show" :file-list="limit" name="img" ref="uploadimg" accept="image/*" :on-exceed="handleExceed"
      :auto-upload="false" :http-request="httpRequest" :on-error="uploadError" :on-change="changeImg"
      :before-upload="handleBeforeUpload" :multiple="isMultiple">
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </section>
</template>

<script>
import { FilesDeleteInId } from "../../api/api";
export default {
  name: "ImageFile",
  props: {
    //图片上传限制
    imgLimit: {
      type: Number,
      default() {
        return 1;
      },
    },
    //图片集合
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    show: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isMultiple: {
      type: Boolean,
      default() {
        return false;
      },
    }
  },
  data() {
    return {
      //图片预览
      dialogImageUrl: "",
      dialogVisible: false,

      upload_flag: false,
      status: "success",
      disabled: false,
      limit: this.value,
      hideUpload: false,
    };
  },
  methods: {
    //图片上传超过数量限制
    handleExceed(files, fileList) {
      this.$message.error(`上传图片不能超过${this.imgLimit}张!`);
    },
    //添加图片后立刻上传到服务器
    httpRequest(param) { },
    // 图片上传失败时
    uploadError() {
      this.$message.error("图片上传失败!");
    },
    changeImg(file, fileList) {
      if (file.name) {
        this.upload_flag = true;
      }
      this.limit.push(file);  //以免覆盖已经通过接口上传的文件
      this.$emit("change", this.limit);
      //判断大于下限定图片数量隐藏添加按钮
      this.hideUpload = this.limit.length >= this.imgLimit;
    },
    // 上传文件之前的钩子
    handleBeforeUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      }
      const maxSize = 15 * 1024 * 1024; // 限制为10MB
      if (file.size > maxSize ) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于15MB",
        });
      }
    },

    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    //删除图片
    handleRemove(file, fileList) {
      let that = this;
      that.$confirm("您确定要删除改图片吗？", "提示", {}).then(() => {
        // if (file.status == that.status) {
        //   that.addLoading = true;
        //   let para = {
        //     id: file.Id,
        //   };
        //   FilesDeleteInId(para).then((res) => {
            
        //     that.addLoading = false;
        //     if (res.data.success) {
        //       that.limit = fileList == undefined ? [] : fileList;
        //       that.$emit("change", that.limit);
        //       that.$message({
        //         message: res.data.msg,
        //         type: "success",
        //       });
        //       //判断小于开放添加图片按钮
        //       that.hideUpload = that.limit.length >= that.imgLimit;
        //     } else {
        //       that.$message({
        //         message: res.data.msg,
        //         type: "error",
        //       });
        //     }
        //   });
        // } else {
          var index = that.limit.findIndex((s) => s.url == file.url);
          that.limit.splice(index, 1);
          that.$emit("change", that.limit);
          //判断小于开放添加图片按钮
          that.hideUpload = that.limit.length >= that.imgLimit;
        //}
      });
    },
  },
  watch: {
    value: function (newval) {
      this.limit = newval;
      //判断大于下限定图片数量隐藏添加按钮
      this.hideUpload = this.limit.length >= this.imgLimit;
    },
  }
};
</script>
<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>